import React from 'react';
import ReactDOM from 'react-dom';
import { CalcFoundationPentagonChart } from '../../../../react/components/molecules/calcFoundationPentagonChart';
import { CalcFoundationUnitTimeChart } from '../../../../react/components/molecules/calcFoundationUnitTimeChart';
import {
  SogoKeisanLevelChart,
  SogoKeisanRankCards,
} from '../../../../react/components/molecules/sogoKeisanLevelChart';
import { PrintUnitGroupsSummary } from '../../../../react/components/molecules/printStudySummary';

// 「成績」タブ（成績のホーム）。計算力レポート（印刷）・講師画面の成績タブと同じ部品で描く。
// 計算力の土台=五角形＋単元タイムグラフ / 総合計算=ランク＋区分別グラフ / テーマ別プリント＋カウントダウン計算。
// 各グラフの「詳細 ›」は、その教材の成績ページ（カテゴリ別のベスト記録）へ飛ばす。
const DETAIL_LINK_LABEL = '詳細 ›';

document.addEventListener('DOMContentLoaded', () => {
  const pentagonMount = document.getElementById('react-calc-foundation-pentagon-section');
  if (pentagonMount != null) {
    const props = JSON.parse(pentagonMount.dataset.json!);

    ReactDOM.render(<CalcFoundationPentagonChart axes={props.axes} />, pentagonMount);
  }

  const unitTimeMount = document.getElementById('react-calc-foundation-unit-time-section');
  if (unitTimeMount != null) {
    const props = JSON.parse(unitTimeMount.dataset.json!);

    ReactDOM.render(<CalcFoundationUnitTimeChart axes={props.axes} />, unitTimeMount);
  }

  const rankCardsMount = document.getElementById('react-sogo-keisan-rank-cards-section');
  if (rankCardsMount != null) {
    const props = JSON.parse(rankCardsMount.dataset.json!);

    ReactDOM.render(<SogoKeisanRankCards levels={props.levels} />, rankCardsMount);
  }

  const sogoKeisanMount = document.getElementById('react-sogo-keisan-section');
  if (sogoKeisanMount != null) {
    const props = JSON.parse(sogoKeisanMount.dataset.json!);

    ReactDOM.render(
      <SogoKeisanLevelChart
        levels={props.levels}
        detailPathByDirectoryKey={props.detailPathByDirectoryKey}
        detailLinkLabel={DETAIL_LINK_LABEL}
      />,
      sogoKeisanMount,
    );
  }

  const printUnitGroupsMount = document.getElementById('react-print-unit-groups-section');
  if (printUnitGroupsMount != null) {
    const props = JSON.parse(printUnitGroupsMount.dataset.json!);

    ReactDOM.render(
      <PrintUnitGroupsSummary
        printUnitGroups={props.printUnitGroups}
        printUnitGroupDetailPathByDirectoryKey={props.printUnitGroupDetailPathByDirectoryKey}
        countdownKeisan={props.countdownKeisan}
        detailLinkLabel={DETAIL_LINK_LABEL}
        // ページ枠が 30rem 固定なので、テーマ別は1カラム・カウントダウン計算は常に縦積み
        isCountdownStacked
      />,
      printUnitGroupsMount,
    );
  }

  // 「カテゴリ別の成績」から戻ってきたときは、URLのアンカー（例: #anzan）の位置まで送る。
  // React の描画前はまだ要素が無く、ブラウザ標準のアンカー移動が効かないためここで送る。
  const anchorId = window.location.hash.slice(1);
  if (anchorId !== '') {
    document.getElementById(anchorId)?.scrollIntoView();
  }
});
